export const formatAppointmentSubmission = selectedSlot => {
  if (!(selectedSlot != null && selectedSlot.startDate) || !(selectedSlot != null && selectedSlot.endDate) || !(selectedSlot != null && selectedSlot.timeZone)) {
    return null;
  }
  return {
    startDate: selectedSlot == null ? void 0 : selectedSlot.startDate,
    endDate: selectedSlot == null ? void 0 : selectedSlot.endDate,
    timeZone: selectedSlot == null ? void 0 : selectedSlot.timeZone
  };
};
//# sourceMappingURL=index.js.map